import React, { Component } from "react";
import intl from "react-intl-universal";
import DivsPattern from "./skylineDesignPattern";
import { Link } from "react-router-dom";

class PurchaseSucceeded extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }
  render() {
    return (
      <DivsPattern headerText={intl.get("Purchase_Succeeded_Title")}>
        <div className="form-label-group">
          <p>{intl.get("Purchase_Succeeded_Text")}</p>
          <p>
            {intl.get("Purchase_Succeeded_Contact_us")}
            <a href="mailto:support@skylineglobe.com">
              {intl.get("Email_Contact_Us")}
            </a>
          </p>
          <div className="text-center">
            <Link to="/account">{intl.get("Go_To_Account")}</Link>
          </div>
        </div>
      </DivsPattern>
    );
  }
}

export default PurchaseSucceeded;
